import { useContext, useId, useState } from "react";
import { PortableText } from "@portabletext/react";
import type { SanityBlockContent } from "../../../../../api/spark";
import CustomComponentsCtx from "../../CustomComponentsCtx";
import { styles } from "./branchBlock.css";

type BranchValue = {
  branches: {
    title: string;
    content: SanityBlockContent;
  }[];
  /** Whether the first tab should be expanded by default. */
  expandFirstTab?: boolean;
};

/**
 * The `Branch` component renders a row of toggle buttons, each revealing its
 * branch's content below. At most one branch is open at a time; clicking the
 * open branch's button closes it again.
 */
const Branch = ({ value }: { value: BranchValue }) => {
  const customComponents = useContext(CustomComponentsCtx)?.customComponents;
  const { branches, expandFirstTab } = value;
  const [openIdx, setOpenIdx] = useState<number | null>(
    expandFirstTab ? 0 : null,
  );
  const contentId = useId();

  const openBranch = openIdx !== null ? branches[openIdx] : undefined;

  return (
    <div className={styles.root}>
      <div className={styles.tabsRow}>
        {branches.map(({ title }, idx) => (
          // type="button" matters: inside a form, a bare button is a submit button.
          <button
            type="button"
            key={idx}
            className={styles.tab}
            aria-expanded={idx === openIdx}
            aria-controls={idx === openIdx ? contentId : undefined}
            onClick={() => setOpenIdx(idx === openIdx ? null : idx)}
          >
            {title}
          </button>
        ))}
      </div>
      {openBranch && (
        <div id={contentId} className={styles.contentBox}>
          <PortableText
            value={openBranch.content}
            components={customComponents}
          />
        </div>
      )}
    </div>
  );
};

export default Branch;
